import { Injectable, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

/**
 * The browser's Back closes an open dialog (task detail, assembly task, client info…) instead of leaving the screen.
 * Opening a top-level dialog adds a history entry for the same URL; Back pops it and MatDialog's closeOnNavigation
 * closes the dialog. Closing the dialog with its own buttons removes that entry again.
 */
@Injectable({ providedIn: 'root' })
export class DialogBackService {
  private readonly dialog = inject(MatDialog);
  private started = false;

  start() {
    if (this.started) return;
    this.started = true;
    this.dialog.afterOpened.subscribe((ref) => {
      if (this.dialog.openDialogs.length !== 1) return; // nested dialogs share the entry of the first one
      history.pushState({ ...(history.state ?? {}), tpDialog: true }, '');
      ref.afterClosed().subscribe(() => {
        if (history.state?.tpDialog) history.back(); // closed by a button: drop the extra entry
      });
    });
  }
}
